// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.style-payment-form[data-v-260d0649] {\n  width: 90%;\n  margin: auto;\n}\n", ""]);
// Exports
module.exports = exports;
